// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()

// Smooth Turbolinks page transitions: fade the incoming body in from transparent
// so the cache-preview → live-render double-swap is imperceptible.
document.addEventListener('turbolinks:before-render', function(event) {
  if (event.data && event.data.newBody) {
    event.data.newBody.style.opacity = '0';
  }
});
document.addEventListener('turbolinks:render', function() {
  requestAnimationFrame(function() {
    document.body.style.transition = 'opacity 0.12s ease-in-out';
    document.body.style.opacity  = '1';
    document.body.addEventListener('transitionend', function handler() {
      document.body.style.transition = '';
      document.body.style.opacity    = '';
      document.body.removeEventListener('transitionend', handler);
    }, { once: true });
  });
});
require("channels")
require("./login")

require("./multi-step-form")
require("./project/service_requested")
require("../src/project/permit_information")
require("../src/project/design_documents_upload")
require("../src/project/organization_select")
require("./custom-radio-button")
require("./clickable-row")
require("./accept_project")
require("./uploads")
require("./clone_form")
require("jquery")
require("./debounce")
require("@nathanvda/cocoon")
require("./sort-table")
require("../shared/column_selector")
require("../shared/column_order")
require("../shared/form_validator")
require("./project_folders")
require("./lead_stages")
require("./filter")
require("./format-search-team-result")
require("./plan_review")
require("./permit_fee_share")
require("./richtext")
require("./copy_link_to_page")
require("./signature")
require("./user_permissions")
require("./user_role_permissions")

// inspections
require("./inspections/note")
require("./inspections/deletable-row")
require("./inspections/invite-contractor-countdown")

// contractor portal
require("./contractor_portal/account_confirmation_form")
require("./contractor_portal/user_onboarding_form")
require("./contractor_portal/email_change")
require("./contractor_portal/dynamic_contractor_type")
require("./contractor_portal/new_permit_form/selection")
require("./contractor_portal/new_permit_form/multi-step-form")
require("./contractor_portal/new_permit_form/permit-information")
require("./contractor_portal/new_permit_form/permit-summary")
require("./contractor_portal/new_permit_form/payment")
require("./contractor_portal/new_permit_form/bank_payment")
require("./contractor_portal/new_permit_form/client")
require("./contractor_portal/permit_fee_structure_form")

// contractor portal v2 permit application
require("./contractor_portal/v2/new_permit_form/multi-step-form")
require("./contractor_portal/v2/new_permit_form/permit-search")
require("./contractor_portal/v2/new_permit_form/form")
require("./contractor_portal/v2/new_permit_form/permit-description-wrapper")

// hud trip report
require("./hud_trip_report/multi-step-form")
require("./hud_signature")

// code enforcement
require("./code_enforcement/multi-step-form")
require("./code_enforcement/form/violation_classification")
require("./code_enforcement/form/form")
require("./ce_case_follow_ups/form")
require("./ce_reinspection")
require("./ce_master_violation")
require("./public_violation_reports/form")

// fees calculator
require("./fees_calculator/del_rio/index")
require("./fees_calculator/del_rio/clone")

// vehicle tracking
require("./vehicles/vehicle_purchase_receipts")
require("./vehicles/vehicle_insurance_documents")
require("./vehicles/odometer_readings")
require("./vehicles/vehicle_pictures")
require("./vehicles/form")
require("./vehicles/mileage_attachments")
require("./vehicles/maintenance_pictures")
require("./vehicles/maintenance_receipts")
require("./vehicles/incident_files")
require("./vehicles/delimiter")
require("./vehicles/vehicle_service_type")
require("./vehicles/insurance_card_photos")
require("./vehicles/offender_license_photos")
require("./vehicles/reassign_vehicle")

require("./building_valuation")

import "chartkick/chart.js"


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")
require('livekit-client')
require('html2canvas')

// Calendar for INSPECTIONS
import "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

// Map for INSPECTIONS
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for Leaflet's default icon paths
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

require('./inspections/contractor-location')
require('./inspections/contractor-location-detail')
require('./inspections/permissions')

require('./trix_custom')
require('./popovers')
require('./organizations')
require('./client_update_modal')
require('./client_update_comment')

// Image Editor
import FilerobotImageEditor from 'filerobot-image-editor';
window.FilerobotImageEditor = FilerobotImageEditor;
require('./inspections/image_editor')

require('./health_inspection_reports/multi-step-form')
require('./health_inspection_reports/temperature_observations')
require('./health_inspection_reports/health_report_calculation')

// Import rollbar for error tracking
import Rollbar from "rollbar";

const rollbar = new Rollbar({
  accessToken: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.NODE_ENV || "development",
  },
  enabled: false
});

window.rollbar = rollbar;

// Import pica for image compression
import pica from 'pica';
window.pica = pica;

// Import CSRF utilities
import { fetchWithCSRF, getCSRFToken, refreshCSRFToken } from './csrf_utils';

// Make functions globally available
window.refreshCSRFToken = refreshCSRFToken;
window.getCSRFToken = getCSRFToken;
window.fetchWithCSRF = fetchWithCSRF;

require('./date_picker')

require("./plan_review/multi-step-form")
require("./plan_review/form")
require("./applicant_portal_admin_setting")

require('./permit_fees')
require('./questionnaire')
require('./permit_files')
require('./permit_form')

require("./google_address")



// knowledge hub js
require('./knowledge_hub/detail_view')
require('./knowledge_hub/video_stream')
require('./knowledge_hub/tags')
require('./knowledge_hub/share_tutorial')
require('./knowledge_hub/reorder')
require('./knowledge_hub/copy_link')

require("./floating_action_button")
require("./chat_conversations")
require("./mobile_upload_handler")
require("./number_input")
require("./permit_chat")
